<div class="button_container">
        <button [class]="buttonStyle" [disabled]="isDisabled" [type]="type" (click)="Onclick()" [ngClass]="{'opacity-50': isDisabled}">{{label}}</button>
</div>
